<script lang="ts">
  import { setContext, type Snippet } from "svelte";
  import { createAccordion } from "@melt-ui/svelte";

  interface Props {
    multiple?: boolean;
    title?: Snippet;
    prefix?: Snippet;
    suffix?: Snippet;
    children?: Snippet;
  }

  let { multiple = false, title, prefix, suffix, children }: Props = $props();

  const {
    elements: { content, item, trigger, root },
    helpers: { isSelected },
    // svelte-ignore state_referenced_locally
  } = createAccordion({
    multiple,
  });

  setContext("accordion", { item, content, trigger, isSelected });
</script>

<div class="divide-y divide-border rounded-2xl p-px shadow-border-inset" {...$root}>
  {#if title}
    <div class="flex items-center justify-between rounded-t-[15px] bg-mono-200 px-4 py-2 text-sm">
      <div class="flex h-6 items-center gap-2">
        {@render prefix?.()}
        {@render title?.()}
      </div>
      {@render suffix?.()}
    </div>
  {/if}

  {@render children?.()}
</div>
